
import About from "./pages/About/About";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import GoogleMeSis from "./pages/Resources/GoogleMeSis"
import Contact from "./pages/Contact";
import Services from "./pages/Services/Services";
import CaseStudies from "./pages/Resources/CaseStudies";
import WebDesign from "./pages/Services/WebDesign"
import Blog from "./pages/Resources/Blog/Blog"
import Testimonials from "./pages/About/Testimonials";
import ShephedLaw from "./pages/Resources/CaseStudies/ShephedLaw";
import CEOGlowUp from "./pages/Services/CEOGlowUp"
import LaunchGlowUp from "./pages/Services/LaunchGlowUp"
import TheBusinessGlowUp from "./pages/Services/TheBusinessGlowUp"
import Blog1Essentials from "./pages/Resources/Blog/Blog1Essentials";
import Blog2Signs from "./pages/Resources/Blog/Blog2Signs";
import Lubbock from "./pages/SEO Pages/Lubbock";
import SanAntonio from "./pages/SEO Pages/SanAntonio";
import Houston from "./pages/SEO Pages/Houston";
import FortWorth from "./pages/SEO Pages/FortWorth";
import Dallas from "./pages/SEO Pages/Dallas";
import Austin from "./pages/SEO Pages/Austin";
import Resources from "./pages/Resources"
import TemplateShop from "./pages/TemplateShop"
import WorkWithMe from "./pages/WorkWithMe"

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/googlemesis" element={<GoogleMeSis />} />
        <Route path="/contact" element={<Contact />} /> 
        <Route path="/services" element={<Services />} />
        <Route path="/casestudies" element={<CaseStudies />} />
        <Route path="/webdesign" element={<WebDesign />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/testimonials" element={<Testimonials />} /> 
        <Route path="/shephedlaw" element={<ShephedLaw />} /> 
        <Route path="/ceoglowup" element={<CEOGlowUp />} />
        <Route path="/launchglowup" element={<LaunchGlowUp />} />
        <Route path="/businessglowup" element={<TheBusinessGlowUp />} />
        <Route path="/essentialswebsitepages" element={<Blog1Essentials />} /> 
        <Route path="/websiteredesignsigns" element={<Blog2Signs />} />
        <Route path="/web-design-seo-women-entrepreneurs-austin" element={<Austin />} />
        <Route path="/dallas-female-founder-website-design" element={<Dallas />} />
        <Route path="/web-design-seo-women-entrepreneurs-fortworth" element={<FortWorth />} />
        <Route path="/houston-female-founder-website-design" element={<Houston />} />
        <Route path="/web-design-seo-women-entrepreneurs-sanantonio" element={<SanAntonio />} />
        <Route path="/lubbock-female-founder-website-design" element={<Lubbock />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/templateshop" element={<TemplateShop />} />
        <Route path="/workwithme" element={<WorkWithMe />} />
        </Routes>
        </div>
  )
}

export default App;
